export default __webpack_public_path__ + "static/media/twenty.17a0511d.jpg";